export default "__VITE_ASSET__BviNtFEE__"